import React, { useState, useEffect, Dispatch } from "react";
import { useBoolean } from "@fluentui/react-hooks";
import i18n from "i18next";

// Fabric Imports
import { fetchWrapper } from "../../../helpers/fetchwrapper";
import { baseUrl } from "../../../helpers/constants";
import { IAppUserDto } from "../../../Models/IAppUserDto";
import { TeamMemberColumns } from "./TeamMemberColumns";
import useWindowSize from "../../../helpers/useWindowSize";
import { useDispatch } from "react-redux";
import { IAppStateDto } from "../../../Models/IAppStateDto";
import { setAppState } from "../../../store/actionCreators";
import {
  Badge,
  Breadcrumb,
  BreadcrumbButton,
  BreadcrumbItem,
  Button,
  DataGrid,
  DataGridBody,
  DataGridCell,
  DataGridHeader,
  DataGridHeaderCell,
  DataGridRow,
  Label,
  MessageBar,
  Tab,
  TabList,
} from "@fluentui/react-components";
import {
  DeleteRegular,
  EmojiRegular,
  EmojiSadRegular,
  IosArrowRtl24Regular,
  PeopleTeamRegular,
} from "@fluentui/react-icons";

import { useNavigate } from "react-router-dom";
import { ITeamIndexDto } from "../../../Models/ITeamIndexDto";
import { ITeamDto } from "../../../Models/ITeamDto";
import { ITeamDeleteMemberDto } from "../../../Models/ITeamDeleteMemberDto";
import { ITeamMemberDto } from "../../../Models/ITeamMemberDto";
import { ITeamRequest } from "../../../Models/ITeamRequest";
import DialogMyInvites from "./DialogMyInvites";
import { MyTeamsColumns } from "./MyTeamsCollumns";
import DialogLeaveTeam from "./DialogLeaveTeam";
import DialogDeleteTeam from "./DialogDeleteTeam";
import DialogAddTeam from "./DialogAddTeam";
import DialogAddColleagueToTeam from "./DialogAddColleagueToTeam";
import { StackShim } from "@fluentui/react-migration-v8-v9";
import Header from "../../Layout/Header";
import { isTouchDevice } from "../../../helpers/helperMethods";
import HeaderTextAnimation from "../../Layout/HeaderTextAnimation";

interface IaddTeamMemberValues {
  teamGuid: string;
  teamName: string;
  name: string;
  email: string;
  anrede: string;
}

function MyTeams() {
  const emailRegEx = /^[\w\.-]+@[a-zA-Z\d\.-]+\.[a-zA-Z]{2,}$/;
  const CheckValidEMailBoolean = (value: string): boolean => {
    return emailRegEx.test(value) ? true : false;
  };
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState<string>(
    i18n.t<string>("members"),
  );
  const [deleteInviteMail, SetDeleteInviteMail] = useState<string>("");
  const windowSize = useWindowSize();
  const [selectedTeam, setSelectedTeam] = useState<ITeamDto>();
  const [hover, setHover] = useState<string>("");

  const [addMemberError, setAddMemberError] = useState<string>("");
  const [acceptInviteError, setAcceptInviteError] = useState<string>("");
  const [declineInviteError, setDeclineInviteError] = useState<string>("");
  const [myInvites, setMyInvites] = useState<ITeamRequest[]>([]);
  const [removeMemberItem, setRemoveMemberItem] =
    useState<ITeamDeleteMemberDto>();
  const [removeInviteItem, setRemoveInviteItem] = useState({
    teamGuid: "",
    email: "",
  });
  const [currentUser, setCurrentUser] = useState<IAppUserDto>();
  const [myOwnTeams, setMyOwnTeams] = useState<ITeamDto[]>([]);
  const [addTeamMemberValues, setAddTeamMemberValues] =
    useState<IaddTeamMemberValues>({
      teamGuid: "",
      teamName: "",
      email: "",
      name: "",
      anrede: "Herr",
    });

  const getMyOwnTeams = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/teams/Get`)
      .then((result: ITeamIndexDto) => {
        setCurrentUser(result.currentUser);
        let tempTeams = result.teams;
        tempTeams.sort((a: ITeamDto, b: ITeamDto) =>
          a.created.localeCompare(b.created),
        );
        setMyOwnTeams(tempTeams);
        if (selectedTeam?.invited.length == 0) {
          setSelectedTab(i18n.t<string>("members"));
        }
      });
  };

  const getInvites = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/teams/GetMyTeamRequests`)
      .then((result: ITeamRequest[]) => {
        setMyInvites(result);
      });
  };

  const [openDeleteTeamDialog, setOpenDeleteTeamDialog] =
    useState<boolean>(false);

  const addMember = (item: IaddTeamMemberValues) => {
    if (CheckValidEMailBoolean(item.email)) {
      fetchWrapper
        .postWithAuth(baseUrl + "/api/teams/AddInvited", item)
        .then((result: any) => {
          getMyOwnTeams();
        })
        .catch((error) => {
          getMyOwnTeams();
          setAddMemberError(error);
        });
    }
  };

  const acceptInvite = (data: any) => {
    fetchWrapper
      .postWithAuth(baseUrl + "/api/teams/ConfirmMembership", {
        requestGuid: data.userObjectGuid,
      })
      .then((result: any) => {
        getMyOwnTeams();
        getInvites();
        refreshAppState();
      })
      .catch((error) => {
        setAcceptInviteError(error);
      });
  };

  const declineInvite = (data: any) => {
    fetchWrapper
      .postWithAuth(baseUrl + "/api/teams/DeclineMembership", {
        teamGuid: data.teamGuid,
        email: data.email,
      })
      .then((result) => {
        getMyOwnTeams();
        getInvites();
        refreshAppState();
      })
      .catch((error) => {
        setDeclineInviteError(error);
      });
  };

  const dispatch: Dispatch<any> = useDispatch();

  const refreshAppState = () => {
    fetchWrapper
      .getWithAuth(`${baseUrl}/api/account/GetAppState`)
      .then((data: IAppStateDto) => {
        dispatch(setAppState(data));
      });
  };
  const columns = TeamMemberColumns({
    deleteMember: (item) => {
      if (selectedTeam?.teamId != undefined) {
        removeMember(selectedTeam.teamId, item);
      }
    },
    currentUser: currentUser,
    hover: hover,
    selectedTeam: selectedTeam,
    deleteInviteEmail: (item) => {
      setRemoveInviteItem({
        email: item,
        teamGuid: selectedTeam?.teamId ? selectedTeam.teamId : "",
      });
    },
  });

  const teamColumns = MyTeamsColumns({
    onSelectTeam: () => {},
    onNavigate: (item) => {
      navigate("/account/myteams?guid=" + item);
    },
  });

  useEffect(() => {
    if (removeInviteItem.email != "") {
      removeInvite(removeInviteItem);
      setRemoveInviteItem({ email: "", teamGuid: "" });
      getMyOwnTeams();
      getInvites();
    }
  }, [removeInviteItem.email]);

  useEffect(() => {
    getMyOwnTeams();
    getInvites();
  }, []);

  useEffect(() => {
    if (selectedTeam?.invited.length == 0) {
      setSelectedTab(i18n.t<string>("members"));
    }
  }, [selectedTeam?.invited.length]);
  const removeMember = (teamGuid: string, userGuid: string) => {
    fetchWrapper
      .post(baseUrl + "/api/teams/DeleteTeamMember", {
        TeamGuid: teamGuid,
        UserGuid: userGuid,
      })
      .then((result: any) => {
        getMyOwnTeams();
        getInvites();
      });
  };

  const removeInvite = (item: any) => {
    fetchWrapper
      .post(baseUrl + "/api/teams/DeleteInvited", {
        teamGuid: item.teamGuid,
        email: item.email,
      })
      .then((result: any) => {
        getMyOwnTeams();
        getInvites();
      });
  };
  const [showInviteSucces, setShowInviteSucces] = useState<boolean>(false);

  useEffect(() => {
    if (myOwnTeams) {
      if (window.location) {
        if (window.location.search) {
          var search = window.location.search.split("=");
          var guid = search[1];
          if (guid) {
            setSelectedTeam(
              myOwnTeams.find((x) => x.teamId == guid)
                ? myOwnTeams.find((x) => x.teamId == guid)
                : undefined,
            );
          }
        } else {
          setSelectedTeam(undefined);
        }
      }
    }
  }, [myOwnTeams, window.location.search]);

  function sortMembers(members: ITeamMemberDto[], currentTeam: ITeamDto) {
    var tempMembers: ITeamMemberDto[] = [...members];

    var owner = tempMembers.find(
      (x: ITeamMemberDto) => x.id == currentTeam.teamOwnerId,
    );
    if (owner) {
      tempMembers = tempMembers.filter(
        (x: ITeamMemberDto) => x.id != currentTeam.teamOwnerId,
      );

      tempMembers.push(owner);
      tempMembers.reverse();
      return tempMembers;
    } else return members;
  }

  return (
    <div>
      {/* Headline */}
      {showInviteSucces && (
        <MessageBar intent="success">
          {i18n.t<string>("memberInvited")}
        </MessageBar>
      )}
      <Header
        HTMLElement={
          <StackShim horizontal verticalAlign="center">
            {(windowSize.width > 1200 ||
              windowSize.width < 1024 ||
              !selectedTeam) && (
              <Button
                icon={<PeopleTeamRegular fontSize={24} color="#ff6600" />}
                size="large"
                appearance="subtle"
                onClick={() => {
                  navigate("/account/myteams");
                }}
              >
                {i18n.t<string>("my-teams").toLocaleUpperCase()}
              </Button>
            )}
            {windowSize.width < 1201 &&
              windowSize.width > 1024 &&
              selectedTeam && (
                <PeopleTeamRegular
                  style={{ paddingLeft: "0px" }}
                  fontSize={24}
                  color="#ff6600"
                  onClick={() => {
                    navigate("/account/myteams");
                  }}
                />
              )}
            {selectedTeam && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <IosArrowRtl24Regular color="#ff6600" />
                <Button size="large" appearance="subtle">
                  <HeaderTextAnimation text={selectedTeam?.teamname} />
                </Button>
              </div>
            )}
          </StackShim>
        }
      />

      {/* ActionBar */}
      {!selectedTeam && myOwnTeams.length != 0 && (
        <div className="lueb-InnerContentBlockPadding2px">
          <DialogAddTeam
            teams={myOwnTeams}
            getMyOwnTeams={() => {
              getMyOwnTeams();
            }}
          />
          <DialogMyInvites
            myInvites={myInvites}
            onDecline={(item: ITeamRequest) => {
              declineInvite(item);
            }}
            onAccept={(item: ITeamRequest) => {
              acceptInvite(item);
            }}
            handleResponseError={acceptInviteError || declineInviteError}
          />
        </div>
      )}
      {/* TabList mit Teams */}
      {myOwnTeams.length > 0 && (
        <div>
          {!selectedTeam && (
            <div className="lueb-ContentBlock">
              <DataGrid
                sortable
                resizableColumns
                items={myOwnTeams}
                columns={teamColumns}
                columnSizingOptions={{ Teamname: { defaultWidth: 300 } }}
              >
                <DataGridHeader>
                  <DataGridRow>
                    {({ renderHeaderCell }) => (
                      <DataGridHeaderCell>
                        {renderHeaderCell()}
                      </DataGridHeaderCell>
                    )}
                  </DataGridRow>
                </DataGridHeader>
                <DataGridBody<ITeamDto>>
                  {({ item, rowId }) => (
                    <DataGridRow<ITeamDto> key={rowId}>
                      {({ renderCell }) => (
                        <DataGridCell>{renderCell(item)}</DataGridCell>
                      )}
                    </DataGridRow>
                  )}
                </DataGridBody>
              </DataGrid>
            </div>
          )}
          {selectedTeam && (
            <div>
              <div
                className="lueb-InnerContentBlockPadding2px"
                style={{ display: "flex", alignItems: "center" }}
              >
                <DialogAddColleagueToTeam
                  manualInviteInfos={(item) => {
                    var newItem: IaddTeamMemberValues = addTeamMemberValues;
                    newItem.anrede = item.anrede;
                    newItem.email = item.email;
                    newItem.name = item.name;
                    if (selectedTeam) {
                      newItem.teamGuid = selectedTeam.teamId;
                      newItem.teamName = selectedTeam?.teamname;
                    }
                    addMember(newItem);
                  }}
                  onInvited={() => {
                    getMyOwnTeams();
                    setShowInviteSucces(true);
                    /*  getInvites(); */
                    setTimeout(() => setShowInviteSucces(false), 7000);
                  }}
                  selectedTeam={selectedTeam}
                />
                {currentUser && currentUser.id != selectedTeam.ownerDto.id && (
                  <DialogLeaveTeam
                    onRemove={() => {
                      if (currentUser) {
                        removeMember(selectedTeam.teamId, currentUser?.id);
                        navigate("/account/myteams");
                      } else {
                        console.log("keinen User gefunden");
                      }
                    }}
                    selectedteam={selectedTeam}
                  />
                )}
                {currentUser && currentUser.id == selectedTeam.teamOwnerId && (
                  <Button
                    onClick={() => {
                      setOpenDeleteTeamDialog(true);
                    }}
                    icon={<DeleteRegular />}
                    appearance="transparent"
                  >
                    {i18n.t<string>("delete")}
                  </Button>
                )}

                <DialogDeleteTeam
                  onUpdate={() => {
                    getMyOwnTeams();
                    navigate("/account/myteams");
                  }}
                  open={openDeleteTeamDialog}
                  onClose={() => setOpenDeleteTeamDialog(false)}
                  selectedTeam={selectedTeam}
                />
              </div>
              <TabList
                selectedValue={selectedTab}
                onTabSelect={(ev, item) => {
                  if (typeof item.value == "string") {
                    setSelectedTab(item.value);
                  }
                }}
                defaultSelectedValue={i18n.t<string>("members")}
              >
                <Tab value={i18n.t<string>("members")}>
                  {i18n.t<string>("members")}{" "}
                  <Badge
                    appearance="filled"
                    style={{ background: "#ff6600", marginLeft: "3px" }}
                  >
                    {selectedTeam?.members.length}
                  </Badge>
                </Tab>
                {myOwnTeams.length != 0 && (
                  <Tab value={i18n.t<string>("invites")}>
                    {i18n.t<string>("invites")}
                    <Badge
                      appearance="filled"
                      style={{
                        background: selectedTeam?.invited.length
                          ? "#ff6600"
                          : " #c1c1c1",
                        marginLeft: "3px",
                        color: selectedTeam?.invited.length ? "" : "#3f3f3f",
                      }}
                    >
                      {selectedTeam?.invited.length != 0 &&
                        selectedTeam?.invited.length}
                      {selectedTeam?.invited.length == 0 && "0"}
                    </Badge>
                  </Tab>
                )}
              </TabList>
              <div className="lueb-ContentBlock">
                {selectedTab == i18n.t<string>("members") && (
                  <div>
                    <DataGrid
                      sortable
                      resizableColumns
                      items={
                        sortMembers(selectedTeam?.members, selectedTeam)
                          ? sortMembers(selectedTeam?.members, selectedTeam)
                          : []
                      }
                      columns={columns}
                      columnSizingOptions={{
                        mailId: { minWidth: 250, defaultWidth: 350 },
                        deleteId: {
                          minWidth: 65,
                        },
                        nameId: { defaultWidth: 300, minWidth: 150 },
                      }}
                    >
                      <DataGridHeader>
                        <DataGridRow>
                          {({ renderHeaderCell }) => (
                            <DataGridHeaderCell>
                              {renderHeaderCell()}
                            </DataGridHeaderCell>
                          )}
                        </DataGridRow>
                      </DataGridHeader>
                      <DataGridBody<ITeamMemberDto>>
                        {({ item, rowId }) => (
                          <DataGridRow<ITeamMemberDto> key={rowId}>
                            {({ renderCell }) => (
                              <DataGridCell
                                onMouseEnter={() => {
                                  if (isTouchDevice() == false) {
                                    setHover(item.email);
                                  }
                                }}
                                onMouseLeave={() => {
                                  setHover("");
                                }}
                              >
                                {renderCell(item)}
                              </DataGridCell>
                            )}
                          </DataGridRow>
                        )}
                      </DataGridBody>
                    </DataGrid>
                  </div>
                )}
                {selectedTeam.invited.length == 0 &&
                  selectedTab == i18n.t<string>("invites") &&
                  i18n.t<string>("noItemsFound")}
                {selectedTab == i18n.t<string>("invites") &&
                  selectedTeam?.invited.length != 0 &&
                  myOwnTeams.length != 0 && (
                    <div>
                      <DataGrid
                        sortable
                        resizableColumns
                        items={
                          selectedTeam?.invited ? selectedTeam?.invited : []
                        }
                        columns={columns}
                        columnSizingOptions={{
                          mailId: { minWidth: 250, defaultWidth: 350 },
                          deleteId: {
                            minWidth: 65,
                          },
                          nameId: { defaultWidth: 300, minWidth: 150 },
                        }}
                      >
                        <DataGridHeader>
                          <DataGridRow>
                            {({ renderHeaderCell }) => (
                              <DataGridHeaderCell>
                                {renderHeaderCell()}
                              </DataGridHeaderCell>
                            )}
                          </DataGridRow>
                        </DataGridHeader>
                        <DataGridBody<IAppUserDto>>
                          {({ item, rowId }) => (
                            <DataGridRow<IAppUserDto>
                              key={rowId}
                              onMouseEnter={() => {
                                if (isTouchDevice() == false) {
                                  setHover(item.email);
                                }
                              }}
                              onMouseLeave={() => {
                                setHover("");
                              }}
                            >
                              {({ renderCell }) => (
                                <DataGridCell>{renderCell(item)}</DataGridCell>
                              )}
                            </DataGridRow>
                          )}
                        </DataGridBody>
                      </DataGrid>
                    </div>
                  )}
              </div>
            </div>
          )}
        </div>
      )}
      {/* Wenn es kein Team gibt */}
      {myOwnTeams.length == 0 && (
        <div>
          <div className="lueb-InnerContentBlockPadding2px">
            <DialogAddTeam
              teams={myOwnTeams}
              getMyOwnTeams={() => getMyOwnTeams()}
            />
            {myInvites.length != 0 && (
              <DialogMyInvites
                myInvites={myInvites}
                onDecline={(item: ITeamRequest) => {
                  declineInvite(item);
                }}
                onAccept={(item: ITeamRequest) => {
                  acceptInvite(item);
                }}
                handleResponseError={acceptInviteError || declineInviteError}
              />
            )}
          </div>
          <div className="lueb-ContentBlock">
            <div
              className="lueb-Padding20"
              style={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {myInvites.length == 0 && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <EmojiSadRegular fontSize={100} />
                  <Label style={{ fontSize: "20px", margin: "15px" }}>
                    {i18n.t<string>("noTeamsFound")}
                  </Label>
                </div>
              )}
              {myInvites.length != 0 && (
                <div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center ",
                      flexDirection: "column",
                    }}
                  >
                    <EmojiRegular fontSize={100} />

                    <Label style={{ fontSize: "20px", margin: "15px" }}>
                      {i18n.t<string>("invitesFound")}
                    </Label>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MyTeams;
